import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Spinner, Box, FlexRow, FlexCol } from 'sarsaparilla';
import { useSelector, useDispatch } from 'react-redux';
import { fetchActivities } from '../../actions/activity';
import ActivityOption from '../../containers/StewardAssetEditPage/ActivityOption';
import { getActivities } from '../../reducers/activities';

const ActivitiesTab = ({
    value,
    activityType,
    isLoading
}) => {
    const {
        id,
        activities: data
    } = value;

    const dispatch = useDispatch();
    const activities = useSelector(state => getActivities(state));

    useEffect(() => {
        dispatch(fetchActivities());
    }, []);

    if (isLoading) {
        return <Spinner isCentered={false} size="xl" />
    }

    return (
        <Box padding={['lg']} background="white" border="gray">
            <FlexRow>
                { activities.map((activity) => (
                    <FlexCol sm={6} lg={4} key={`activity-${activity.id}`}>
                        <ActivityOption
                            assetId={id}
                            activityType={activityType}
                            activity={activity}
                            value={data.find((record) => record.activityId === activity.id)} />
                    </FlexCol>
                ))}
            </FlexRow>
        </Box>
    );
}

ActivitiesTab.propTypes = {
    value: PropTypes.shape({
        id: PropTypes.string,
        activities: PropTypes.arrayOf(PropTypes.shape({
            activityId: PropTypes.number,
            assetId: PropTypes.string,
            name: PropTypes.string
        }))
    }),
    activityType: PropTypes.string,
    assetDetails: PropTypes.shape({
        name: PropTypes.string,
        singular: PropTypes.string
    }),
    isLoading: PropTypes.bool
};

ActivitiesTab.defaultProps = {
    value: []
};

export default ActivitiesTab;
